import { sharedEn } from '@cold-ambulance/ui';

const en = {
  ...sharedEn,
} as const;

export default en;
